import type { MessageContext } from 'vue-i18n';
import type { InfractionText } from './types';

export const portInfractions: Record<string, InfractionText> = {
  HIGH_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation: (ctx: MessageContext) => {
      let dbType = 'database';
      if (
        typeof ctx.values.service === 'string' &&
        (ctx.values.service.includes('RabbitMQ') || ctx.values.service.includes('Kafka'))
      ) {
        dbType = 'data handling';
      }
      const port = ctx.named('port') as string;
      const service = ctx.named('service') as string;
      return `Port ${port} is used for the ${service} ${dbType} service. This port being open potentially means that sensitive data that is stored in the service is exposed.`;
    },
    whyRisk: 'Why is this high risk?',
    risk: 'Databases, and other data handling services, contain valuable data that attackers actively target. If {service} on port {port} is accessible externally, it could allow unauthorised users to access, modify, or steal sensitive information. Common attack vectors include brute force attacks on weak credentials, exploitation of unpatched vulnerabilities, and SQL injection attacks.',
  },
  MEDIUM_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for the {service} database service. This port being open potentially means that sensitive data that is stored in the service is exposed.',
    whyRisk: 'Why is this a medium risk?',
    risk: 'Databases, and other data handling services, contain valuable data that attackers actively target. If {service} on port {port} is accessible externally, it could allow unauthorised users to access, modify, or steal sensitive information. Common attack vectors include brute force attacks on weak credentials, exploitation of unpatched vulnerabilities, and SQL injection attacks.',
  },
  LOW_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for the {service} database service. This port being open potentially means that sensitive data that is stored in the service is exposed.',
    whyRisk: 'Why is this a low risk?',
    risk: 'Databases, and other data handling services, contain valuable data that attackers actively target. If {service} on port {port} is accessible externally, it could allow unauthorised users to access, modify, or steal sensitive information. Common attack vectors include brute force attacks on weak credentials, exploitation of unpatched vulnerabilities, and SQL injection attacks.',
  },
};
